import { useMutation, useQuery } from "./urqlHooks";

const BANKBALANCE = `
query AllBankBalances($companyId:String!){
    allBankBalances(companyId: $companyId) {
      bankId
      availableBalance
      amountApproved
      amountUsed
      creditLineAvailable
      currencyType
      accountNumber
      createdAt
      includeInCashFlow
    }
  }
`;

export const GetBankBalanceData = companyId => {
  const [result, reexecuteQuery] = useQuery({
    query: BANKBALANCE,
    variables: { companyId },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const CREATE_BANK_BALANCE = `
mutation CreateBankBalance($companyId: String!, $data: [BankBalancesInput!]!) {
  createBankBalance(companyId: $companyId, data: $data) {
    status
    message
  }
}
`;

export const CreateBankBalance = () => {
  const [result, executeMutation] = useMutation(CREATE_BANK_BALANCE);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};
